// ============================================================
// Silk Route — WhatsApp welcome-offer journey (sr2wa)
// Inline card + timed popup + 20%→15% fallback.
//
// States:  initial_20  → (8s) → timed_20 (02:00 ring) → fallback_15
// Persistence: localStorage holds a single expiry timestamp, so the
// countdown survives refresh / tab changes and the expired state sticks.
// Config (links, timings) comes from #sr2wa-config, rendered by
// snippets/sr2-wa-offer.liquid from the section settings.
// ============================================================

(function () {
  'use strict';

  var KEY = 'sr2WaOffer.v1';

  var cfgEl = document.getElementById('sr2wa-config');
  var card = document.querySelector('[data-sr2wa-inline]');
  var popup = document.getElementById('sr2wa-popup');
  if (!cfgEl || !card || !popup) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.url20 || !cfg.url15) return;

  // Never auto-run timers/popups inside the Shopify theme editor.
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // ── Storage (private-mode safe) ──
  var mem = null;
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || mem; } catch (e) { return mem; }
  }
  function save(s) {
    mem = s;
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* fall back to memory */ }
  }

  // ── Elements ──
  var inlineHead = card.querySelector('[data-sr2wa-inline-head]');
  var inlineSub = card.querySelector('[data-sr2wa-inline-sub]');
  var popupHead = popup.querySelector('[data-sr2wa-popup-head]');
  var popupSub = popup.querySelector('[data-sr2wa-popup-sub]');
  var popupCta = popup.querySelector('[data-sr2wa-popup-cta]');
  var popupCtaTxt = popup.querySelector('[data-sr2wa-popup-cta-txt]');
  var popupTime = popup.querySelector('[data-sr2wa-popup-time]');
  var ringWrap = popup.querySelector('[data-sr2wa-ring-wrap]');
  var ring = popup.querySelector('[data-sr2wa-ring]');
  var RING_C = 326.73; // 2πr, r=52

  var COUNTDOWN = Math.max(10, parseInt(cfg.countdownSeconds, 10) || 120);
  var DELAY = Math.max(0, isNaN(parseInt(cfg.delaySeconds, 10)) ? 8 : parseInt(cfg.delaySeconds, 10));

  var mode = 'initial'; // initial | timed | expired
  var tickTimer = null;
  var delayTimer = null;
  var lastFocus = null;

  // ── Tracking ──
  function track(percent, placement, state, secs) {
    var p = { offer_percent: percent, placement: placement, state: state };
    if (secs != null) p.seconds_remaining = secs;
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: 'WhatsAppOfferClick' };
      for (var k in p) dl[k] = p[k];
      window.dataLayer.push(dl);
    } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', 'WhatsAppOfferClick', p); } catch (e) {}
    try { if (typeof fbq === 'function') fbq('trackCustom', 'WhatsAppOfferClick', p); } catch (e) {}
  }

  function remaining() {
    var s = load();
    if (!s || !s.exp) return null;
    return Math.max(0, Math.ceil((s.exp - Date.now()) / 1000));
  }

  function fmt(secs) {
    var m = Math.floor(secs / 60), s = secs % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  // ── Inline card rendering ──
  function renderInline() {
    if (mode === 'expired') {
      inlineHead.innerHTML = '<s aria-hidden="true">20%</s> Claim your 15% code';
      if (inlineSub) inlineSub.textContent = '15% on your first order, in one message.';
      card.href = cfg.url15;
    } else {
      inlineHead.textContent = 'Claim your 20% code';
      card.href = cfg.url20;
      if (mode === 'timed' && inlineSub) {
        var r = remaining();
        inlineSub.innerHTML = 'Held for the next <strong class="sr2wa-inline-time">' + fmt(r == null ? COUNTDOWN : r) + '</strong>';
      }
    }
  }

  // ── Popup rendering ──
  function renderPopup() {
    if (mode === 'expired') {
      popupHead.textContent = 'Your 20% off deal has expired';
      popupSub.textContent = 'We can still do 15% off your first order. Claim it now';
      popupCtaTxt.textContent = 'Claim my 15% off';
      popupCta.href = cfg.url15;
      ringWrap.hidden = true;
    } else {
      popupHead.textContent = '20% off on your first order!';
      popupSub.textContent = 'Yours for the next few minutes. Claim it now!';
      popupCtaTxt.textContent = 'Claim my 20% off';
      popupCta.href = cfg.url20;
      ringWrap.hidden = false;
      paintRing(remaining());
    }
  }

  function paintRing(r) {
    if (r == null) r = COUNTDOWN;
    if (popupTime) popupTime.textContent = fmt(r);
    if (ring) ring.style.strokeDashoffset = String(RING_C * (1 - r / COUNTDOWN));
  }

  function openPopup() {
    if (!popup.hidden) { renderPopup(); return; }
    renderPopup();
    popup.hidden = false;
    lastFocus = document.activeElement;
    try { popupCta.focus({ preventScroll: true }); } catch (e) {}
  }

  function closePopup(markDismissed) {
    if (popup.hidden) return;
    popup.hidden = true;
    if (markDismissed) {
      var s = load() || {};
      if (mode === 'expired') s.dFall = true; else s.dTimed = true;
      save(s);
    }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ── Countdown engine ──
  function tick() {
    var r = remaining();
    if (r == null) return;
    if (r <= 0) { expire(); return; }
    if (mode === 'timed') {
      var t = card.querySelector('.sr2wa-inline-time');
      if (t) t.textContent = fmt(r);
      if (!popup.hidden) paintRing(r);
    }
  }

  function startTicking() {
    if (tickTimer) return;
    tickTimer = setInterval(tick, 500);
  }

  function beginCountdown() {
    var s = load() || {};
    if (!s.exp) { s.exp = Date.now() + COUNTDOWN * 1000; save(s); }
    mode = 'timed';
    renderInline();
    startTicking();
    if (!s.dTimed) openPopup();
  }

  function expire() {
    if (tickTimer) { clearInterval(tickTimer); tickTimer = null; }
    var wasOpen = !popup.hidden;
    mode = 'expired';
    renderInline();
    var s = load() || {};
    if (wasOpen || !s.dFall) openPopup();
  }

  // Arrive on an already-expired state (refresh after timer ran out):
  // keep inline in fallback, show the expired popup only if never dismissed.
  function resumeExpired() {
    mode = 'expired';
    renderInline();
    var s = load() || {};
    if (!s.dFall) openPopup();
  }

  // ── Click handling ──
  function onOfferClick(placement, e) {
    var r = mode === 'timed' ? remaining() : null;
    var state = mode === 'expired' ? 'fallback_15' : (mode === 'timed' ? 'timed_20' : 'initial_20');
    var percent = mode === 'expired' ? 15 : 20;
    track(percent, placement, state, r);
    if (placement === 'popup') closePopup(true);
  }

  card.addEventListener('click', onOfferClick.bind(null, 'inline'));
  popupCta.addEventListener('click', onOfferClick.bind(null, 'popup'));

  popup.querySelectorAll('[data-sr2wa-close]').forEach(function (el) {
    el.addEventListener('click', function () { closePopup(true); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup(true);
  });

  // Multi-tab sync: another tab starting/finishing the countdown updates us.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    var r = remaining();
    if (r != null && r > 0 && mode !== 'timed') { mode = 'timed'; renderInline(); startTicking(); }
    if (r != null && r <= 0 && mode !== 'expired') expire();
  });

  // ── Boot ──
  renderInline();
  if (designMode) return; // static initial state only in the theme editor

  var r0 = remaining();
  if (r0 == null) {
    delayTimer = setTimeout(beginCountdown, DELAY * 1000);
  } else if (r0 > 0) {
    beginCountdown();
  } else {
    resumeExpired();
  }
})();
